import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { selectSelectedCompanyId } from '@mkp/company/state';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

export const redirectToCompanyEditGuard = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectSelectedCompanyId).pipe(
    filter((companyId): companyId is string => companyId != null),
    take(1),
    map((companyId) => router.createUrlTree(['/', AppConfig.routes.company, 'edit', companyId]))
  );
};
